import { Component, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'issues-no-communication-grid-item',
    templateUrl: './issues-no-communication-grid-item.component.html'
})

export class IssuesNoCommunicationGridItemComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['noCommunicationPage']) {
                    this.page = +queryParams['noCommunicationPage'];
                }
            }));

        this.getData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.issuePaygGetNoCommunicationPaged(this.clientId, this.page, this.pageSize, this.siteId).then(
            result => {
                this.dataService.issuesNoCommunicationGridItemComponentResolved.next(result.items.length > 0);
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
            },
            error => {
                this.dataService.issuesNoCommunicationGridItemComponentResolved.next(false);
            }
        );
    }

    onInfoClick() {
        swal({
            title: 'Latest connection to PAYG unit',
            html: '<p style="text-align: left;">This widget shows you the last time the PAYG unit connected.</p>\
            <p style="text-align: left;">Switch2 PAYG units use mobile networks to communicate with Switch2 HQ. If a unit is not connecting daily, it could indicate that there is a fault or no power supply.</p>\
            <p style="text-align: left;">A PAYG unit that does not communicate is unable to send metering data to Switch2 and will prevent top-ups being received.</p>\
            <p style="text-align: left;">Let us know if any properties are void so we can make sure our records are up to date. You may wish to contact the consumers identified by this widget to rule out any welfare issues.</p>\
            <p style="text-align: left;">If you would like to speak to us regarding PAYG connectivity call our customer services team.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
